import React from 'react';

import { SVGProps } from './SVGProps';

const StepOneIcon = ({ fill = 'none', width = '40', height = '40' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 42 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5692_9821)">
        <g clipPath="url(#clip1_5692_9821)">
          <path d="M26.7081 41.1641H16.2061" stroke={fill} strokeWidth="1.203" strokeMiterlimit="10" />
          <path
            d="M16.2753 41.9499C16.2628 41.0859 15.9953 40.245 15.5063 39.5327C15.0172 38.8204 14.3285 38.2685 13.5268 37.9465C12.725 37.6245 11.8459 37.5467 11 37.723C10.1542 37.8992 9.3793 38.3215 8.77279 38.9369C8.16628 39.5522 7.75523 40.3332 7.59131 41.1815C7.42738 42.0298 7.51791 42.9077 7.85149 43.7047C8.18508 44.5017 8.74684 45.1823 9.46616 45.661C10.1855 46.1397 11.0302 46.395 11.8943 46.3949C12.4738 46.3907 13.0468 46.2724 13.5806 46.0467C14.1144 45.8211 14.5986 45.4925 15.0054 45.0797C15.4122 44.667 15.7337 44.1781 15.9516 43.6411C16.1695 43.1041 16.2795 42.5294 16.2753 41.9499Z"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M35.4042 41.9499C35.3918 41.0859 35.1242 40.245 34.6352 39.5327C34.1461 38.8204 33.4574 38.2685 32.6557 37.9465C31.8539 37.6245 30.9748 37.5467 30.129 37.723C29.2831 37.8992 28.5082 38.3215 27.9017 38.9369C27.2952 39.5522 26.8841 40.3332 26.7202 41.1815C26.5563 42.0298 26.6468 42.9077 26.9804 43.7047C27.314 44.5017 27.8758 45.1823 28.5951 45.661C29.3144 46.1397 30.1592 46.395 31.0232 46.3949C31.6027 46.3907 32.1757 46.2724 32.7095 46.0467C33.2433 45.8211 33.7275 45.4925 34.1343 45.0797C34.5411 44.667 34.8626 44.1781 35.0805 43.6411C35.2984 43.1041 35.4084 42.5294 35.4042 41.9499Z"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M7.58103 41.1639H1.43203C1.3226 41.1634 1.21434 41.1412 1.11347 41.0988C1.0126 41.0564 0.921084 40.9945 0.84417 40.9167C0.767257 40.8388 0.706455 40.7466 0.665248 40.6452C0.62404 40.5438 0.603235 40.4353 0.604026 40.3259V34.9889C0.603235 34.8796 0.623973 34.7713 0.665056 34.67C0.706139 34.5688 0.766762 34.4766 0.843464 34.3988C0.920166 34.321 1.01144 34.259 1.11209 34.2165C1.21273 34.174 1.32077 34.1517 1.43003 34.1509H40.704V40.3259C40.7048 40.4351 40.6841 40.5435 40.643 40.6447C40.6019 40.746 40.5413 40.8381 40.4646 40.916C40.3879 40.9938 40.2966 41.0557 40.196 41.0983C40.0953 41.1408 39.9873 41.1631 39.878 41.1639H35.328"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M40.7042 35.3508V27.6508C40.7044 27.4694 40.6535 27.2916 40.5572 27.1378L35.3952 18.9258C35.3112 18.7915 35.1945 18.6806 35.0559 18.6036C34.9174 18.5267 34.7616 18.4861 34.6032 18.4858H26.6392"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M26.639 31.2199V14.8579C26.6417 14.4736 26.4916 14.1038 26.2218 13.8301C25.9519 13.5563 25.5844 13.4009 25.2 13.3979H2.04404C1.85362 13.3993 1.66533 13.4381 1.4899 13.5121C1.31448 13.5862 1.15537 13.6941 1.02165 13.8297C0.887935 13.9653 0.782232 14.1259 0.710577 14.3023C0.638923 14.4787 0.602721 14.6675 0.604039 14.8579V31.2199"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M30.104 21.949V27.136H36.07L32.903 22.236C32.8472 22.1495 32.7707 22.0783 32.6804 22.0289C32.5901 21.9795 32.4889 21.9534 32.386 21.953L30.104 21.949Z"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path d="M13.151 29.4611V19.3731L10.979 20.6621V19.3621L13.151 18.0811H14.345V29.4611H13.151Z" fill={fill} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5692_9821">
          <rect width="41.315" height="47" fill="white" />
        </clipPath>
        <clipPath id="clip1_5692_9821">
          <rect width="41.315" height="34.208" fill="white" transform="translate(0 12.792)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StepOneIcon;
